
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosuratcabservice() {



    const cardData =
    {
        keyword: 'Pune to Surat cab Service ',
        heading: 'Platinum24 Cabs: Pune to Surat cab Service',
        headingDescription: ' Platinum24 Cabs offers dependable Pune to Surat cab service, catering to business travelers, families, and tourists seeking a comfortable long-distance ride. Whether you’re heading to Surat for corporate work, visiting relatives, or exploring attractions like Sarthana Nature Park and the city’s textile hubs, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth and safe journey. With professional chauffeurs, on-time pickups, and transparent pricing, we make intercity travel stress-free. From one-way trips to return packages, Platinum24 Cabs guarantees a reliable and pleasant Pune to Surat travel experience.',

        top: 'Top Places to Visit in Surat with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Surat Castle",
    "description": "Surat Castle, built in the 16th century by Sultan Mahmud III, is a historic fort designed to protect the city from Portuguese and Dutch invasions. Its massive stone walls and bastions narrate stories of Gujarat’s maritime past. Today, it serves as a heritage monument and tourist attraction. Visitors admire its robust architecture and history. It offers scenic views of the Tapi River. Surat Castle is the city’s proud heritage landmark."
  },
  {
    "title": "Sarthana Nature Park and Zoo",
    "description": "Sarthana Zoo, spread across 80 hectares, is one of the largest zoological parks in Gujarat. It houses lions, tigers, elephants, and various exotic animals. Families love its open enclosures and greenery. Educational programs make it engaging for children. The park also has a botanical section with diverse plant species. Sarthana Zoo is Surat’s family-friendly wildlife retreat."
  },
  {
    "title": "Dutch Garden",
    "description": "The Dutch Garden in Surat is a beautifully landscaped colonial-era cemetery and garden. It houses the tombs of Dutch and British officials, showcasing European-style architecture. Well-maintained lawns and pathways make it perfect for evening strolls. Photographers love its historical charm. The Tapi River flowing nearby adds to its serenity. Dutch Garden is Surat’s peaceful colonial heritage site."
  },
  {
    "title": "Jagadishchandra Bose Aquarium",
    "description": "The Jagadishchandra Bose Aquarium is India’s first multi-level public aquarium, featuring over 100 species of freshwater and marine life. Sharks, jellyfish, and stingrays are major attractions. Educational exhibits teach about marine ecosystems. Families and children enjoy its interactive displays. It blends entertainment with knowledge. The aquarium is Surat’s underwater world of discovery."
  },
  {
    "title": "ISKCON Surat",
    "description": "ISKCON Temple in Surat is a grand spiritual center dedicated to Lord Krishna and Radha. Its architecture blends tradition with modernity. The temple conducts daily aartis, bhajans, and cultural programs. Festivals like Janmashtami draw thousands of devotees. The temple’s calm ambiance offers peace in the bustling city. ISKCON Surat is a spiritual oasis of devotion."
  },
  {
    "title": "Tapi Riverfront",
    "description": "The Tapi Riverfront is a scenic attraction developed for recreation and leisure. Jogging tracks, gardens, and boating facilities make it popular among locals. Sunset views over the Tapi River are mesmerizing. Cultural events and fairs are often held here. Families enjoy picnics and peaceful evenings. Tapi Riverfront is Surat’s modern lifestyle destination."
  },
  {
    "title": "Dumas Beach",
    "description": "Dumas Beach, located 21 km from Surat, is a popular weekend spot on the Arabian Sea. Known for its black sand, it is surrounded by legends and mysteries. Street food stalls serving bhajiya, sweet corn, and local snacks add flavor. Visitors enjoy horse rides, camel rides, and evening walks. Sunsets here are spectacular. Dumas Beach is Surat’s scenic coastal retreat."
  },
  {
    "title": "Gopi Talav",
    "description": "Gopi Talav is a 16th-century artificial lake built by Malik Gopi, a nobleman of Gujarat. Recently redeveloped, it features boating, gardens, and cultural spaces. Families enjoy its amusement rides and light shows. The lake has historic significance in Surat’s growth. Its modern facilities attract locals and tourists alike. Gopi Talav is Surat’s blend of history and leisure."
  },
  {
    "title": "Chintamani Jain Temple",
    "description": "Chintamani Jain Temple, built in the 17th century, is one of Surat’s most revered shrines. Its wooden interiors and painted ceilings depict Jain legends and stories. The temple houses idols of Jain Tirthankaras in a peaceful ambiance. Pilgrims visit to seek blessings and admire the art. It is a spiritual and cultural treasure of the city. Chintamani Temple is Surat’s sacred heritage gem."
  },
  {
    "title": "VR Surat Mall",
    "description": "VR Surat Mall is the city’s premier shopping and entertainment hub. It houses national and international brands, multiplex cinemas, and a vibrant food court. Events, exhibitions, and cultural programs are often hosted here. Families enjoy weekend outings in its lively ambiance. Its modern design and wide variety of stores make it popular. VR Surat Mall is Surat’s modern lifestyle hotspot."
  }
],


                     "services": [
    {
      "name": "Pune to Surat Cab",
      "description": "Travel from Pune to Surat with our premium Pune to Surat Cab service that guarantees a safe, comfortable, and hassle-free journey. Whether you’re traveling for business, leisure, or family visits, our fleet of well-maintained cars, ranging from sedans to SUVs, is available to suit your specific needs. Professional drivers with extensive knowledge of the route ensure timely arrivals, smooth driving, and a pleasant experience. Enjoy flexible booking options, 24/7 customer support, and transparent pricing with no hidden charges. Perfect for travelers seeking reliability and comfort on this popular intercity route."
    },
    {
      "name": "Pune to Surat Taxi",
      "description": "Our Pune to Surat Taxi service offers you a reliable and convenient travel solution for one-way or round trips. With professional chauffeurs trained to prioritize your safety and comfort, you can relax and enjoy the scenic drive. Vehicles are regularly sanitized and equipped with modern amenities including air conditioning, GPS tracking, and comfortable seating. Whether you need a quick day trip or a longer outstation journey, our taxi service is tailored to meet diverse requirements while ensuring competitive pricing and hassle-free booking."
    },
    {
      "name": "Book Pune to Surat Cab",
      "description": "Easily book your Pune to Surat Cab through our user-friendly online platform or mobile app, designed to make your travel planning seamless and quick. Choose your preferred vehicle type, select pickup and drop locations, and get instant fare estimates with secure payment options. Our booking system provides real-time availability updates and instant confirmation to help you travel stress-free. Enjoy special offers and discounts for early bookings, group travel, or frequent riders, making your trip economical without compromising on quality."
    },
    {
      "name": "Pune to Surat Cab Booking Online",
      "description": "Our online booking service for Pune to Surat Cab offers unparalleled convenience for travelers who want to secure their ride anytime, anywhere. The platform supports multiple payment methods and allows you to customize your trip, including stopovers or additional luggage requirements. Customer service is available 24/7 to assist with any queries or last-minute changes. With detailed vehicle profiles and driver ratings, you can make informed decisions to ensure a comfortable and safe journey."
    },
    {
      "name": "Pune to Surat One Way Taxi",
      "description": "Choose the Pune to Surat One Way Taxi service for affordable, single-direction travel that’s perfect for relocation, business trips, or family visits. This option provides the flexibility of a one-way journey without the obligation of a return trip, helping you save costs. Our vehicles are well-maintained and spacious, offering a smooth ride even on long-distance routes. Drivers are experienced with highway driving and ensure timely pickups and drop-offs, making your journey stress-free and efficient."
    },
    {
      "name": "Pune to Surat Car Hire",
      "description": "Rent a car for your Pune to Surat trip with our flexible Pune to Surat Car Hire service, offering options ranging from compact cars to luxury SUVs. Whether you prefer self-drive freedom or a chauffeur-driven experience, we have packages to fit your preferences. Our vehicles undergo rigorous maintenance and regular cleaning to ensure safety and comfort throughout the journey. Transparent pricing and customizable rental durations make this service ideal for business travelers, tourists, and families alike."
    },
    {
      "name": "Surat to Pune Taxi Booking",
      "description": "Plan your return trip from Surat to Pune with our efficient Surat to Pune Taxi Booking service, designed to provide comfortable rides, timely pickups, and professional drivers. Whether returning after a business trip, family visit, or vacation, our taxis ensure a smooth and safe journey. You can book online or via phone with instant confirmation, transparent fare details, and 24/7 support for any travel adjustments."
    },
    {
      "name": "Pune to Surat Outstation Cabs",
      "description": "Our Pune to Surat Outstation Cabs provide an excellent option for intercity travel with a focus on comfort and reliability. Ideal for long-distance trips, these cabs are equipped with features like ample legroom, climate control, and space for luggage, ensuring you reach your destination refreshed. Experienced drivers with thorough knowledge of the routes take care of navigation and traffic management, allowing you to relax throughout your journey. Flexible booking options and competitive fares make these outstation cabs a popular choice."
    },
    {
      "name": "Pune to Surat Cab Fare",
      "description": "Get clear, upfront Pune to Surat Cab Fare information with no hidden fees or surprise charges. Our fare structure is competitive and transparent, factoring in distance, vehicle type, and any additional services like tolls or waiting time. You can easily access fare estimates online or via our customer service team, helping you budget your trip effectively. Special discounts for frequent travelers and group bookings add extra value to your fare."
    },
    {
      "name": "Affordable Cabs from Pune to Surat",
      "description": "Travel smart with our Affordable Cabs from Pune to Surat, offering budget-friendly pricing while maintaining high standards of safety and comfort. Perfect for students, professionals, and families, these economical cabs don’t compromise on quality. We provide a range of vehicles tailored to your budget and needs, with no hidden costs and transparent fare estimates. Flexible payment options and seasonal discounts make these affordable cabs an ideal choice for cost-conscious travelers."
    },
    {
      "name": "Pune to Surat Private Taxi",
      "description": "Experience personalized travel with our Pune to Surat Private Taxi service, ideal for travelers seeking privacy, flexibility, and direct routes. Whether traveling alone, with family, or a small group, enjoy a dedicated vehicle and driver exclusively at your disposal. Customize your itinerary with stops, sightseeing, or detours, and benefit from professional service focused on your convenience. All vehicles are sanitized regularly and fitted with modern amenities to ensure a comfortable and safe ride."
    }
  ],
  "tableData": [
    ["Pune to Surat Cab", "Pune to Surat Taxi"],
    ["Book Pune to Surat Cab", "Pune to Surat Cab Booking Online"],
    ["Pune to Surat One Way Taxi", "Pune to Surat Car Hire"],
    ["Surat to Pune Taxi Booking", "Pune to Surat Outstation Cabs"],
    ["Pune to Surat Cab Fare", "Affordable Cabs from Pune to Surat"],
    ["Pune to Surat Private Taxi", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to Surat Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable cab services for your Pune to Surat journey, ensuring a hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Your Travel Needs",
    "WhyChoosedescription": "Choose from sedans, SUVs, hatchbacks, and tempo travellers tailored to your group size for Pune to Surat trips."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Safe Travel",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized to provide a safe and hygienic environment throughout your journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Surat Routes",
    "WhyChoosedescription": "Our professional drivers know the best routes between Pune and Surat to ensure timely and smooth travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent fares that include fuel, tolls, and driver allowances for hassle-free travel."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist you with your Pune to Surat cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages to Suit Your Schedule",
    "WhyChoosedescription": "Choose hourly, daily, or customized rental plans designed for your Pune to Surat travel needs."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Surat cab quickly and securely through our website or app with immediate confirmation."
  }
]
























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Surat cab service?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services from Pune to Surat with professional drivers and well-maintained vehicles.',
    },
    {
        question: 'How can I book a cab from Pune to Surat?',
        answer: 'You can book your cab easily through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Surat travel?',
        answer: 'We provide a range of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit your preferences and budget.',
    },
    {
        question: 'Is one-way cab service available from Pune to Surat?',
        answer: 'Yes, both one-way and round-trip cab services are available for Pune to Surat travel.',
    },
    {
        question: 'Are the drivers experienced for Pune to Surat long-distance trips?',
        answer: 'Absolutely, our drivers are licensed, professional, and familiar with the Pune to Surat route.',
    },
    {
        question: 'Can I customize pickup and drop-off locations in Pune and Surat?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Pune and Surat.',
    },
    {
        question: 'What safety and hygiene protocols are followed for Pune to Surat cabs?',
        answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene measures to ensure passenger safety.',
    },
    {
        question: 'Is Pune to Surat cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 for Pune to Surat cab bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Surat cab bookings?',
        answer: 'We accept cash, UPI, digital wallets, and major credit/debit cards for hassle-free payments.',
    },
    {
        question: 'Are customizable packages available for Pune to Surat cab service?',
        answer: 'Yes, we offer flexible and customizable packages tailored to your travel itinerary and preferences.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajay Patel',
        feedback: 'The Pune to Surat cab service by Platinum24 Cabs was punctual and very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha Desai',
        feedback: 'Great experience with Platinum24 Cabs for my Pune to Surat trip. Friendly driver and clean vehicle.',
        rating: 5,
    },
];














































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneToSuratCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Surat Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-surat-cab.jpg",
  "description": "Book Pune to Surat cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable, safe, and available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-surat-cab-service"
  }
};




    return (
        <div>



<Helmet>
  <title>Pune to Surat Cab Service | Affordable Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Surat cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable, safe, and available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Surat Cab, Pune to Surat Taxi, Book Pune to Surat Cab, Pune to Surat Cab Booking Online, Pune to Surat One Way Taxi, Pune to Surat Car Hire, Surat to Pune Taxi Booking, Pune to Surat Outstation Cabs, Pune to Surat Cab Fare, Affordable Cabs from Pune to Surat, Pune to Surat Private Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToSuratCabSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/108.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosuratcabservice;